import { Link } from "react-router-dom";
import { ArrowLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export const PageHeader = ({ eyebrow, title, description, action, backTo, demo = false }: { eyebrow?: string; title: string; description: string; action?: React.ReactNode; backTo?: string; demo?: boolean }) => (
  <header className="relative flex flex-col gap-4 border-b border-border/70 pt-5 pb-6 md:flex-row md:items-end md:justify-between" data-testid="page-header">
    <span className="page-header-accent" aria-hidden="true" />
    <div className="flex min-w-0 items-start gap-3">
      {backTo && (
        <Button variant="outline" size="icon" asChild className="mt-1 shrink-0" data-testid="page-header-back-button">
          <Link to={backTo} aria-label="Go back"><ArrowLeft className="size-4" /></Link>
        </Button>
      )}
      <div>
        <div className="mb-2 flex flex-wrap items-center gap-2">
          {eyebrow && <p className="text-xs font-semibold uppercase tracking-[0.16em] text-primary" data-testid="page-header-eyebrow">{eyebrow}</p>}
          {demo && <Badge variant="outline" className="border-accent/30 bg-accent/10 text-[10px] uppercase tracking-wider text-accent-foreground" data-testid="demo-mode-badge">Preview — Mock Data</Badge>}
        </div>
        <h1 className="text-2xl font-semibold tracking-tight text-foreground md:text-3xl" data-testid="page-header-title">{title}</h1>
        <p className="mt-2 max-w-3xl text-sm leading-6 text-muted-foreground" data-testid="page-header-description">{description}</p>
      </div>
    </div>
    {action && <div className="flex shrink-0 items-center gap-2" data-testid="page-header-action">{action}<ChevronRight className="hidden size-4 text-muted-foreground md:block" aria-hidden="true" /></div>}
  </header>
);
